import { render } from "./Home.vue?vue&type=template&id=3d9b9a9a"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import exportComponent from "/Users/isaias/Developer/Trayectics/Trayectics-Questions/trayectics_questions/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__